import axios from "axios";

const Token = localStorage.getItem("token");

// const api = "https://backend.fieldofficer.staging.vibhohcm.com/api/";
const api = "https://backend.fieldofficer.vibhohcm.com/api/";

const createAxiosInstance = (token) => {
  const instance = axios.create({
    baseURL: `${api}/`,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      "x-token": Token,
    },

  });


  // Response Interceptor: Handle expired token (401)
  instance.interceptors.response.use(
    (response) => {
      // Log successful responses
      // console.log("API Success:", response);
      return response;
    },
    async (error) => {

      // console.log("❌ API Error Response:", error.response);

      const originalRequest = error.config;

      // check if token expired (401 + Token error)
      if (
        error.response &&
        error.response.status === 401 &&
        error.response?.data?.message?.toLowerCase().includes("token") &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        localStorage.removeItem("token");  // remove token
        localStorage.removeItem("role");  // remove role
        window.location.href = "/superadmin";  // redirect to login
      }

      return Promise.reject(error);
    }
  );

  return instance;
};




export const instance = createAxiosInstance(Token);

export const updateToken = (newToken) => {
  instance.defaults.headers["Authorization"] = `Bearer ${newToken.trim()}`;
  instance.defaults.headers["x-token"] = newToken;
};

export default instance;
